<template>
  <div
    class="image-wrapper"
    style="width: fit-content; position: relative; max-width: 100%"
  >
    <v-img
      @click="openLightbox"
      v-if="displayMode === 'full-width'"
      width="100%"
      max-width="100%"
      height="auto"
      :src="src"
      :contain="true"
    />
    <v-img
      @click="openLightbox"
      v-else-if="displayMode === 'max-height'"
      max-width="100%"
      width="auto"
      :height="size"
      :src="src"
      :contain="true"
    />
    <v-img
      @click="openLightbox"
      v-else-if="displayMode === 'width'"
      max-width="100%"
      :width="size"
      height="auto"
      :src="src"
      :contain="true"
    />
    <v-img
      @click="openLightbox"
      v-else-if="displayMode === 'height'"
      max-width="100%"
      width="auto"
      :height="size"
      :src="src"
      :contain="true"
    />
    <div class="file-name">{{ fileName }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { ImageMode } from "components/Wysiwyg/extensions/attachment/attachment-item/AttachmentItemNodeView.vue"
import { LightboxService } from "features/gallery/lightbox/lightbox.service"

export default defineComponent({
  name: "RenderedImage",
  props: {
    src: String,
    size: {
      type: String,
      required: false,
    },
    lightboxWidth: {
      type: Number,
      required: false,
      default: 0,
    },
    lightboxHeight: {
      type: Number,
      required: false,
      default: 0,
    },
    displayMode: {
      type: String as PropType<ImageMode>,
      required: true,
    },
    lightboxService: {
      type: Object as PropType<LightboxService>,
      required: true,
    },
    fileName: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const openLightbox = () => {
      props.lightboxService.openPhotoLightbox(0, 1, (index) => {
        return Promise.resolve({
          src: props.src,
          width: props.lightboxWidth,
          height: props.lightboxHeight,
        })
      })
    }

    return { openLightbox }
  },
})
</script>

<style scoped>
.file-name {
  display: none;
  position: absolute;
  bottom: 0;
  background: #0a0a0a99;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  color: white;
  justify-content: center;
  padding: 4px;
}

.image-wrapper:hover .file-name {
  display: flex;
}
</style>
